<div
  [class]="containerClass + ' default-container'"
  [style.width]="containerWidthUnit"
  [style.height]="containerHeightUnit"
>
  <div
    [style.width]="containerWidthUnit"
    [style.height]="calcContainerHeight"
    [class]="elemClass"
    [@imageAnimation]="contentCtrl"
  >
    <div class="sk-cube-grid d-inline">
      <div class="sk-cube sk-cube1"></div>
      <div class="sk-cube sk-cube2"></div>
      <div class="sk-cube sk-cube3"></div>
      <div class="sk-cube sk-cube4"></div>
      <div class="sk-cube sk-cube5"></div>
      <div class="sk-cube sk-cube6"></div>
      <div class="sk-cube sk-cube7"></div>
      <div class="sk-cube sk-cube8"></div>
      <div class="sk-cube sk-cube9"></div>
    </div>
  </div>

  <img
    [class]="imgClass"
    [width]="imageWidth"
    [height]="calcImageHeight"
    [src]="urlImg"
    (load)="onLoadImg($event)"
    (error)="onErrorImg()"
    [@imageAnimation]="imageCtrl"
    #lImage
  />
</div>
